<template>
    <div class="route-loader" v-if="show">
        <div class="spinner"></div>
    </div>
</template>

<script setup lang="ts">
import { useUiStore } from '@/stores/ui'
import { storeToRefs } from 'pinia'

const ui = useUiStore()
const { anyLoading } = storeToRefs(ui)
const show = anyLoading
</script>

<style scoped lang="stylus">
.route-loader
    position fixed
    z-index 90
    inset 0
    display flex
    align-items center
    justify-content center
    background var(--app-bg-color)

.spinner
    width 48px
    height 48px
    border 4px solid var(--app-loader-bg)
    border-top-color var(--app-main-accent-color)
    border-radius 50%
    animation spin 0.9s linear infinite

@keyframes spin
    to
        transform rotate(360deg)
</style>
